import { Component, Input, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
    selector: 'el-email-badge',
    templateUrl: './email-badge.component.html',
    styleUrls: ['./email-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailBadgeComponent implements OnChanges {

  /**
   * Text to display in badge
   */
  @Input() text: string;

  /**
   * Size of badge. Can be small (default), medium, large or fluid (adapts to the content)
   */
  readonly size = input('default');

  /**
   * Add style to badge
   */
  readonly badgeStyleClass = input('');

  readonly color = input('');

  // Generates single letter for badge
  makeBadge(text) {
    if (text) {
      return text.slice(0, 1).toUpperCase();
    }
  }

  ngOnChanges() {
    this.text = this.makeBadge(this.text);
  }

}
